import { IPenData } from '@leafer-ui/interface'

import { GroupData } from './GroupData'


export class PenData extends GroupData implements IPenData {

}
